// extracted by css-extract-rspack-plugin
export default {"tabs":"jk76A"};